import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
// import { useAuth } from "../Auth/Auth";
import {apiHeader} from '../../../utils/apiHeader'
import axios from "axios";
import { globalConfig } from "../../../config/config";
// const querystring = require("querystring");

const ManageContentFacades = ({ location }) => {
  const [contentFacadeIndexTypes, setContentFacadeIndexTypes] = useState([]);
  let parms = new URLSearchParams(location.search);
  const [message, setMessage] = useState("");
  const {token,userMetadata}=useAuth()
  const history = useHistory();
  const [entitlements, setEntitlements] = useState([]);
  useEffect(() => {
    handleOnLoad();
  }, []);
  const [state, setState] = useState({
    contentFacadeId: parseInt(parms.get("id")),
    contentId: 0,
    contentFacadeTypeId: 0,
    securityContextId: 0,
    serverModuleValueCode: 0,
    contentFacadeName: "",
    contentFacadeDescription: "",
    effectiveDate: new Date().toISOString(),
    expirationDate: new Date().toISOString(),
    lastUpdateUser: 0,
    lastUpdateDate: new Date().toISOString(),
  });

  function handleSave(event) {
    console.log("handling save 1");

    event.preventDefault();
    console.log("handling save");

    var url = `${globalConfig.apiDatahubUrl}/content-facades/${state.contentFacadeId}`;

    axios
      .patch(url, state, apiHeader(token))
      .then((response) => {
        console.log("response.data");
        console.log(response.status + ":" + response.data.contentInputSourceId);

        if (response.status === 200) {
          setMessage("Success");
          setInterval(() => {
            window.location.reload();
          }, 1000);
        } else {
          setMessage("Failed");
        }
        console.log(message);
        event.preventDefault();
      })
      .catch((err) => {
        console.log("error - " + err);
      });
    console.log("message info - " + message);
  }

  function handleChange(event) {
    console.log(event);
    var target = event.target;
    console.log(target.id + ":" + target.value);
    setState({
      ...state,
      [target.id]: isNaN(target.value)
        ? target.value
        : target.value === ""
        ? ""
        : parseInt(target.value),
    });

    console.log(state);
  }

  const handleOnLoad = () => {
    axios
      .get(
        `${globalConfig.apiDatahubUrl}/content-facade-types`,
        apiHeader(token)
      )
      .then((res) => {
        const contentFacadeIndexTypes = res.data;
        console.log(contentFacadeIndexTypes);
        setContentFacadeIndexTypes(contentFacadeIndexTypes);
      });

    axios
      .get(
        `${globalConfig.systemCodesUrl}/ENTITLEMENTS`,
        apiHeader(token)
      )
      .then((res) => {
        const entitlements = res.data;
        console.log("results", entitlements);
        setEntitlements(entitlements);
      })
      .catch((err) => {
        console.log("here");
        console.log(err);
      });

    console.log("handleOnLoad() - loading id = " + state.contentFacadeId);
    axios
      .get(
        `${globalConfig.apiDatahubUrl}/content-facades/${state.contentFacadeId}`,
        apiHeader(token)
      )
      .then((res) => {
        const contentType = res.data;
        console.log("contentType");
        console.log(contentType);
        setState(contentType);
        console.log("state");
        console.log(state);
      });
  };

  function onDelete() {
    let deleteID = state.contentFacadeId;
    axios
      .delete(
        `${globalConfig.apiDatahubUrl}/content-facades/` + deleteID,
        apiHeader(token)
      )
      .then((res) => {
        console.log("Delete Response:" + res.data);
        history.goBack();
      })
      .catch((err) => console.log("Err delete:" + err));
  }
  return (
    <form>
      <div className="container-fluid">
      <button
          type="button"
          className="btn btn btn-outline-secondary mt-2 mb-3"
          onClick={() => history.goBack()}
        >
          Go Back
        </button>
        <h4>Manage Content Facades</h4>
        <hr />
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Choose Facade">
            Choose Facade
          </label>
          <select
            onchange="submit()"
            id="contentFacades"
            className="form-control input-xlarge col-sm-8"
            value="#{contentFacadeForm.currentContentFacade.contentFacadeId}"
            valueChangeListener="#{contentFacadeForm.get}"
          >
            <option value="#{contentFacadeForm.contentFacadeSelectList}" />
          </select>
        </div>
        <hr />
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Content Object Name">
            Content Object Name
          </label>
          <input
            readOnly={true}
            id="contentId"
            className="form-control input-xlarge col-sm-8"
            // value={this.contentObjectName}
          />
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Facade Type">
            Facade Type
          </label>
          <select
            id="contentFacadeTypeId"
            className="form-control input-xlarge col-sm-8"
            value={state.contentFacadeTypeId}
            onChange={handleChange}
          >
            {/* <option value="#{contentFacadeForm.contentFacadeTypeSelectList}" /> */}
            <option>Select Facade Type</option>
            {contentFacadeIndexTypes.map(
              ({ contentFacadeTypeDescr, contentFacadeTypeId }) => (
                <option key={contentFacadeTypeId} value={contentFacadeTypeId}>
                  {contentFacadeTypeDescr}
                </option>
              )
            )}
          </select>
          {/* <SelectListComponent entityName ={"system-code-values"} valueFilterColumnName = {"systemCodeId"} valueFilter = {"235"} displayColumnName ={"systemCodeValueValue"} keyColumnName ={"systemCodeValueId"}
				IdName={"contentFacadeTypeId"}
				TypeId={state.contentFacadeTypeId}
				handle={handleDropDown}
				/>	 */}
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Facade Object">
            Facade Object
          </label>
          <input
            id="contentFacadeName"
            className="form-control input-xlarge col-sm-8"
            value={state.contentFacadeName}
            onChange={handleChange}
          />
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Description">
            Description
          </label>
          <textarea
            id="contentFacadeDescription"
            className="form-control input-xlarge col-sm-8"
            cols="60"
            rows="5"
            value={state.contentFacadeDescription}
            onChange={handleChange}
          />
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Server Module">
            Server Module
          </label>
          <select
            id="serverModuleValueCode"
            className="form-control input-xlarge col-sm-8"
            value={state.serverModuleValueCode}
            onChange={handleChange}
          >
            <option value={0}>Select Entitlement </option>
            {entitlements.map(
              ({ systemCodeId, systemCodeValueValue, systemCodeValueId }) => (
                <option key={systemCodeValueId} value={systemCodeValueId}>
                  {systemCodeValueValue}{" "}
                </option>
              )
            )}
          </select>
        </div>
        <hr />
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="Last Updated By #{ombUserSession.getUserNameForId(contentTemplateForm.currentContentTemplate.lastUpdateUser)} on "
          >
            Last Updated By
          </label>
          <input
            className="form-control col-sm-1"
            readonly="readonly"
            value={state.lastUpdateUser}
          />
        </div>
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="#{contentTemplateForm.currentContentTemplate.lastUpdateDate}"
          >
            Last Update Date
          </label>
          <input
            className="form-control col-sm-8"
            readonly="readonly"
            value={state.lastUpdateDate.slice(0, 16)}
            type="datetime-local"
          />
        </div>
        <hr />
        {/* &nbsp; */}
        <button
          className="btn btn-danger"
          value="Delete"
          onClick={onDelete}
        >
          {" "}
          Delete
        </button>
        &nbsp;
        <button className="btn btn-success" value="Save" onClick={handleSave}>
          Save
        </button>

      </div>
    </form>
  );
};

export default ManageContentFacades;
